import React from 'react'
import { required, SelectInputProps } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { DepSelectInput } from '../../inputs/DepSelectInput'
import { COMMON_FIELDS } from '../../../providers/localization/constant'

const RESOURCE_PREFIX = 'resources.promotions.banners.fields'

const defaultProps = {
  label: `${COMMON_FIELDS}.target_link.label`,
  source: 'action_type',
  choices: [
    { id: 'promotions', name: `${RESOURCE_PREFIX}.target_link.choices.promotion` },
    { id: 'external_browser', name: `${RESOURCE_PREFIX}.target_link.choices.external_browser` },
  ],
}

export const PromotionTargetLinkSelectInput: React.FC<SelectInputProps> = ({
  label,
  source,
  choices,
  disabled = false,
  ...props
}) => {
  const { setValue } = useFormContext()

  const targetLinkOnChange = (e): void => {
    const value = e.target.value
    setValue('action_type', value)
  }
  return (
    <DepSelectInput
      depField='action'
      expectedValue='link'
      margin='none'
      disabled={disabled}
      fullWidth
      label={label}
      source={source}
      choices={choices}
      validate={[required()]}
      translateChoice={true}
      onChange={targetLinkOnChange}
      {...props}
    />
  )
}

PromotionTargetLinkSelectInput.defaultProps = defaultProps
